module.exports = __webpack_public_path__ + "static/media/Post box.7ef2b3ec.jpg";